module.exports = __webpack_public_path__ + "img/5.dc92f9d8.webp";